// removed by extract-text-webpack-plugin
module.exports = {"KanbanLoader":"Kanban__KanbanLoader__3I00-","SpinnerHolder":"Kanban__SpinnerHolder__3WCxY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kanban/Kanban.css
// module id = 382
// module chunks = 0